import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionLink } from 'components/action-button';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

interface SignUpToContinueActionLinkProps {
  disabled?: boolean;
}

const SignUpToContinueActionLink: React.FC<SignUpToContinueActionLinkProps> = ({ disabled }) => {
  const { formatMessage } = useIntl();
  const showSignUpToContinue = useFlag(LaunchDarklyFlag.ENABLE_SIGNUP_CART_BUTTON_TEXT);
  const { setOriginLocation } = useAuthContext();
  const handleSignUpToContinueClick = () => {
    setOriginLocation(routes.cart);
  };

  const label = formatMessage({ id: showSignUpToContinue ? 'signUpToContinue' : 'continue' });

  if (disabled) {
    return (
      <ActionButton disabled fullWidth>
        {label}
      </ActionButton>
    );
  }

  return (
    <ActionLink onClick={handleSignUpToContinueClick} to={routes.signUp} fullWidth>
      {label}
    </ActionLink>
  );
};

export default SignUpToContinueActionLink;
